const semanticClassNames = {
    filledIcon: 'stars-rating-bar__filled-icon',
    emptyIcon: 'stars-rating-bar__empty-icon',
    button: 'stars-rating-bar__button',
    buttonInteractive: 'stars-rating-bar__button--interactive',
};
export default semanticClassNames;
//# sourceMappingURL=StarsRatingBar.semanticClassNames.js.map